import { Injectable } from '@angular/core';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BlockedSlotSaveFacade } from '../+store/blocked-slot-save.facade';

import { BlockedSlotSaveModalComponent } from '../containers/blocked-slot-save-modal/blocked-slot-save-modal.component';
import { BlockedSlotSaveInputModel } from '../models/blocked-slot-save-input.model';

@Injectable({
    providedIn: 'root'
})
export class BlockedSlotSaveLauncherService {
    constructor(
        private bsModalService: BsModalService,
        private blockedSlotFacade: BlockedSlotSaveFacade
    ) { }

    openBlockedSlotSave(input: BlockedSlotSaveInputModel) {
        this.bsModalService.show(BlockedSlotSaveModalComponent, {
            id: 1,
            class: 'fullscreen',
            initialState: { input }
        });
    }
}
